import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {classNames} from "primereact/utils";
import {MultiSelect} from "primereact/multiselect";
import {Form, Field} from 'react-final-form';

import PartnercontactListService from "../_services/partnercontact/PartnercontactListService";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Message} from "primereact/message";
import ReceiptSendService from "../_services/receipt/ReceiptSendService";
import PartnerShowService from "../_services/partner/PartnerShowService";

const ReceiptSendComponent = (props) => {

  const [formData, setFormData] = useState({email: ''});
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [hasEmailableContacts, setHasEmailableContacts] = useState(null);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      partnerContacts: selectedContacts,
      email: (data.email || formData.email || '').trim()
    };
    ReceiptSendService(window.App.state.props.id, payload)
      .then(response => {
        setLoading(false)
        window.App.toastShow('success', 'Sikeres küldés!');
        window.App.setState({
          dialogReceiptSend: false
        })
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setLoading(false)
      })
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    if(window.App.state.props && window.App.state.props.partner && window.App.state.props.partner.id) {
      Promise.all([
        PartnercontactListService('', window.App.state.props.partner.id),
        PartnerShowService(window.App.state.props.partner.id)
      ])
        .then(([contactsResponse, partnerResponse]) => {
          const items = contactsResponse?.data?.data?.items || [];
          const emailableContacts = items.filter(item => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.email || ''));
          setHasEmailableContacts(emailableContacts.length > 0);
          if (emailableContacts[0]) {
            setContacts(emailableContacts)
          } else {
            setFormData(current => ({
              ...current,
              email: partnerResponse?.data?.data?.email || partnerResponse?.data?.email || ''
            }))
          }
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <div className={"p-grid"}>
          <div className={"p-col-12"}>
            <Field name="contacts" render={({input, meta}) => (
              <div className="p-field p-fluid">
                <label htmlFor="contacts"
                       className={classNames({'p-error': isFormFieldValid(meta)})}>Kapcsolattartó(k)</label>
                <span className="p-d-block">
                  {contacts && contacts[0] ? (
                    <MultiSelect options={contacts}
                                 optionLabel="name"
                                 optionValue="id"
                                 emptyMessage={"Még nincs munkavállaló..."}
                                 onChange={(e) => {
                                   input.onChange(e.value)
                                   setSelectedContacts(e.value)
                                 }}
                                 id={"contacts"}
                                 value={selectedContacts}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                  ) : (
                    <MultiSelect options={contacts}
                                 disabled
                                 className={"disabled"}/>
                  )}
                </span>
                {getFormErrorMessage(meta)}
                {hasEmailableContacts === false && (
                  <Message
                    severity="warn"
                    className="p-mt-2 p-d-flex"
                    text="Ennek a partnernek nincs aktív, e-mail-címmel rendelkező kapcsolattartója. Az e-mail-cím kézzel is megadható."
                  />
                )}
              </div>
            )}/>
          </div>
          <div className={"p-col-12"}>
            <Field name="email" render={({input, meta}) => (
              <div className="p-field p-fluid">
                <label htmlFor="email"
                       className={classNames({'p-error': isFormFieldValid(meta)})}>Email cím</label>
                <span className="p-d-block">
                  <InputText id="email" {...input}
                             onChange={(e) => {
                               input.onChange(e.target.value)
                               setFormData(current => ({...current, email: e.target.value}))
                             }}
                             value={input.value || ''}
                             className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                </span>
                {getFormErrorMessage(meta)}
              </div>
            )}/>
          </div>
        </div>
        <div className={"p-grid p-mt-1"}>
          <div className={"p-col-12 p-lg-6 p-xl-6"}>

          </div>
          <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
            <Button type="submit" label="Küldés" icon={"pi pi-envelope"} loading={loading}
                    className="p-button-info"/>
          </div>
        </div>
      </form>
    )}/>
  )
}
export default withTranslation('common')(ReceiptSendComponent);
